import {
  CalendarHoliday,
  ICalendarHoliday,
  ICalendarHolidayData,
  ITimeOffCalendar,
  TimeOffCalendar
} from '@/models';
import { ITimeOffCalendarState } from '@/store/timeoff-calendar';

import { ITimeOffCalendarGetters } from './getters.types';

export const getters: ITimeOffCalendarGetters = {
  getTimeOffCalendars(state: ITimeOffCalendarState): ITimeOffCalendar[] {
    return state.calendars.map(data => new TimeOffCalendar(data));
  },

  getTimeOffCalendarById: (state: ITimeOffCalendarState) => (
    id: number
  ): ITimeOffCalendar | undefined => {
    const data = state.calendars.find(calendar => calendar.id === id);

    if (!data) {
      return undefined;
    }

    return new TimeOffCalendar(data);
  },

  getLatestTimeOffCalendar(
    state: ITimeOffCalendarState
  ): ITimeOffCalendar | undefined {
    let largestYear = 0;
    state.calendars.forEach(calendar => {
      if (calendar.id! > largestYear) {
        largestYear = calendar.id!;
      }
    });

    const data = state.calendars.find(calendar => calendar.id === largestYear);

    if (!data) {
      return undefined;
    }

    return new TimeOffCalendar(data);
  },
  //holidays
  getCalendarHolidays: (state: ITimeOffCalendarState) => (
    calendar: number
  ): ICalendarHoliday[] => {
    let list: ICalendarHoliday[] = [];

    const calendarTimeOff = state.calendarHolidays.find(
      calendarHoliday => calendarHoliday.calendar === calendar
    );

    if (!calendarTimeOff) {
      return [];
    }

    const holidayList = (calendarTimeOff.holidays as ICalendarHolidayData[]).map(
      data =>
        new CalendarHoliday({
          ...data,
          calendar: calendarTimeOff.calendar
        })
    );
    list = list.concat(holidayList);

    return list;
  },

  getCalendarsHolidays: (state: ITimeOffCalendarState) => (
    calendars: number[]
  ): ICalendarHoliday[] => {
    let list: ICalendarHoliday[] = [];

    calendars.forEach(calendar => {
      const calendarTimeOff = state.calendarHolidays.find(
        calendarHoliday => calendarHoliday.calendar === calendar
      );

      if (!calendarTimeOff) return;

      const holidayList = (calendarTimeOff.holidays as ICalendarHolidayData[]).map(
        data =>
          new CalendarHoliday({
            ...data,
            calendar: calendarTimeOff.calendar
          })
      );
      list = list.concat(holidayList);
    });

    return list;
  },

  getCalendarHolidayById: (state: ITimeOffCalendarState) => (
    id: number,
    calendar: number
  ): ICalendarHoliday | undefined => {
    const calendarTimeOff = state.calendarHolidays.find(
      calendarHoliday => calendarHoliday.calendar === calendar
    );

    if (!calendarTimeOff) {
      return undefined;
    }

    const holiday = (calendarTimeOff.holidays as ICalendarHolidayData[]).find(
      calendarHoliday => calendarHoliday.id === id
    );

    if (!holiday) {
      return undefined;
    }

    return new CalendarHoliday(holiday);
  }
};
